/**
 * Stories for the variants handle these stories.
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { Box } from '@zillow/constellation-10';
import { GhostCard } from 'src/experiences/MortgageDashboard/common/components/GhostCard';

type ResourceCardLayoutProps = {
    title: ReactNode;
    copy: ReactNode;
    cta: ReactNode;
    modal: ReactNode;
};
const MINIMUM_HEIGHT_TO_AVOID_CLS = '204px';
const CLSGuard = styled.div`
    min-height: ${MINIMUM_HEIGHT_TO_AVOID_CLS};
`;

export const ResourceCardLayout: FunctionComponent<ResourceCardLayoutProps> = ({ title, copy, cta, modal }) => (
    <GhostCard bottom>
        <CLSGuard>
            <Box css={{ marginTop: 'sm', marginBottom: 'lg' }}>{title}</Box>
            <Box css={{ marginBottom: 'lg' }}>{copy}</Box>
            {cta}
            {modal}
        </CLSGuard>
    </GhostCard>
);
